__turbopack_context__.v({
  "service-teaser-list": "service-teaser-list-component-module-scss-module__EEY9Ra__service-teaser-list",
  "service-teaser-list__list": "service-teaser-list-component-module-scss-module__EEY9Ra__service-teaser-list__list",
});
